import { Grid2, Box, Typography } from "@mui/material"
import background from "../../../ui-utils/photos/bgvideo.mp4"
import LeaderWebViewStyles from "./Mob.module.css"
import Jitesh from "../../../ui-utils/latestPics/Jitesh.png"
import Pooja from "../../../ui-utils/latestPics/Pooja.png"
import Dubey from "../../../ui-utils/latestPics/Dubey.jpg"
import Prashant from "../../../ui-utils/latestPics/Prashant1.jpeg"
import Manish from "../../../ui-utils/latestPics/Manish1.png"
import en from "../../../i18n/English/Aboutus/management.json";
import hi from "../../../i18n/Hindi/Aboutus/management.json";
import kn from "../../../i18n/Kannada/Aboutus/management.json";
import ma from "../../../i18n/Marathi/Aboutus/management.json";
import gu from "../../../i18n/Gujarati/Aboutus/management.json";
import { useLanguage } from "../../../Context/LangContext";
import { useState,useEffect, useRef } from "react"
export default function MobileManagement() {

    const { language } = useLanguage();
    const translations = { en, hi, kn, gu, ma };
    const t = translations[language] || translations.en;


    const [isFlipped, setIsFlipped] = useState(false);
    const [isFlipped2, setIsFlipped2] = useState(false);
    const [isFlipped3, setIsFlipped3] = useState(false);
    const [isFlipped4, setIsFlipped4] = useState(false);
    const [isFlipped5, setIsFlipped5] = useState(false);

    const touchStartY = useRef(null);
    const hasScrolled = useRef(false);


    const touchStartY1 = useRef(null);
    const hasScrolled1 = useRef(false);

    const touchStartY2 = useRef(null);
    const hasScrolled2 = useRef(false);

    const touchStartY3 = useRef(null);
    const hasScrolled3 = useRef(false);

    const backRef1 = useRef(null);
    const backRef2 = useRef(null);
    const backRef3 = useRef(null);
    const backRef4 = useRef(null);
    const backRef5 = useRef(null);


    useEffect(() => {
        if (isFlipped && backRef1.current) {
            backRef1.current.scrollTop = 0;
        }
    }, [isFlipped]);



    useEffect(() => {
        if (isFlipped2 && backRef2.current) {
            backRef2.current.scrollTop = 0;
        }
    }, [isFlipped2])

    useEffect(() => {
        if (isFlipped3 && backRef3.current) {
            backRef3.current.scrollTop = 0;
        }
    }, [isFlipped3])


    useEffect(() => {
        if (isFlipped4 && backRef4.current) {
            backRef4.current.scrollTop = 0;
        }
    }, [isFlipped4])

    useEffect(() => {
        if (isFlipped5 && backRef5.current) {
            backRef5.current.scrollTop = 0;
        }
    }, [isFlipped5])


    const handleTouchStart = (e) => {
        touchStartY.current = e.touches[0].clientY;
        hasScrolled.current = false;
    };

    const handleTouchMove = (e) => {
        const currentY = e.touches[0].clientY;
        if (Math.abs(currentY - touchStartY.current) > 10) {
            hasScrolled.current = true;
        }
    };

    const handleTouchEnd = (flippedSetter) => () => {
        if (!hasScrolled.current) {
            flippedSetter((prev) => !prev);
        }
      };

    const handleTouchStart1 = (e) => {
        touchStartY1.current = e.touches[0].clientY;
        hasScrolled1.current = false;
    };

    const handleTouchMove1 = (e) => {
        const currentY= e.touches[0].clientY;
        if (Math.abs(currentY - touchStartY1.current) > 10) {
            hasScrolled1.current = true;
        }
    };

    const handleTouchEnd1 = (flippedSetter) => () => {
        if (!hasScrolled1.current) {
            flippedSetter((prev) => !prev);
        }
    };


    const handleTouchStart2 = (e) => {
        touchStartY2.current = e.touches[0].clientY;
        hasScrolled2.current = false;
    };

    const handleTouchMove2 = (e) => {
        const currentY = e.touches[0].clientY;
        if (Math.abs(currentY - touchStartY2.current) > 10) {
            hasScrolled2.current = true;
        }
    };

    const handleTouchEnd2 = (flippedSetter) => () => {
        if (!hasScrolled2.current) {
            flippedSetter((prev) => !prev);
        }
    };

    const handleTouchStart3 = (e) => {
        touchStartY3.current = e.touches[0].clientY;
        hasScrolled3.current = false;
    };

    const handleTouchMove3 = (e) => {
        const currentY = e.touches[0].clientY;
        if (Math.abs(currentY - touchStartY3.current) > 10) {
            hasScrolled3.current = true;
        }
    };

    const handleTouchEnd3 = (flippedSetter) => () => {
        if (!hasScrolled3.current) {
            flippedSetter((prev) => !prev);
        }
    };
    return (
        <>
            <Box className={LeaderWebViewStyles.HomeSectionBox}>

                <Grid2 sx={{ width: "100%" }}>

                    {/* <h1 className={LeaderWebViewStyles.leader_title}>{t.heading}</h1> */}
                    <div className={LeaderWebViewStyles.headingContainer}>
                        <div className={LeaderWebViewStyles.gradientBackground}></div>
                        <Typography className={LeaderWebViewStyles.leader_title} style={{ fontWeight: 600 }}>
                            {t.heading}
                        </Typography>
                    </div>

                    <Grid2 className={LeaderWebViewStyles.inner_card}>
                        {/* <Grid2  className={LeaderWebViewStyles.leader_card1}>

                                    <Typography className={LeaderWebViewStyles.ex_subtit}>Mr. Narayana B. Shetty</Typography>
                                    <Typography className={LeaderWebViewStyles.ex_subtit1}>MD &amp; Chiarman</Typography>
                                    <Typography className={LeaderWebViewStyles.ex_subtit2}>Mr. Shetty is a seasoned professional,
                                        possessing over more than four decades of
                                        experience in the Indian Stock Market as well
                                        as Financial Markets.</Typography>

                                </Grid2> */}
                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd(setIsFlipped)}
                        >
                            <Grid2 className={LeaderWebViewStyles.flip_card}>
                                <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                        <img src={Jitesh} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.management[0].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.management[0].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_back1} >
                                        <div className={LeaderWebViewStyles.flip_back_content} ref={backRef1} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.management[0].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.management[0].designation}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[0].name}</span>{t.management[0].description}
                                        </Typography>
                                        </div>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped2 ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={handleTouchStart1}
                            onTouchMove={handleTouchMove1}
                            onTouchEnd={handleTouchEnd1(setIsFlipped2)}
                        >

                            <Grid2 className={LeaderWebViewStyles.flip_card} sx={{ marginTop: "42px" }}>
                                <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                        <img src={Pooja} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.management[1].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.management[1].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_back1} >
                                        <div className={LeaderWebViewStyles.flip_back_content} ref={backRef2} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.management[1].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.management[1].designation}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[1].name}</span>{t.management[1].description}
                                        </Typography>
                                        </div>
                                    </Grid2>
                                </Grid2>
                            </Grid2>

                        </Grid2>

                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped3 ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={handleTouchStart2}
                            onTouchMove={handleTouchMove2}
                            onTouchEnd={handleTouchEnd2(setIsFlipped3)}
                            sx={{ marginTop: "82px" }}
                        >
                            <Grid2 className={LeaderWebViewStyles.flip_card} >
                                <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                        <img src={Dubey} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.management[2].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.management[2].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_back1} >
                                        <div className={LeaderWebViewStyles.flip_back_content} ref={backRef3} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.management[2].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.management[2].designation}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[2].name}</span>{t.management[2].description}
                                        </Typography>
                                        </div>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>


                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped4 ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={() => setIsFlipped4(!isFlipped4)}
                            sx={{ marginTop: "42px" }}
                        >
                            <Grid2 className={LeaderWebViewStyles.flip_card} >
                                <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                        <img src={Prashant} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.management[3].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.management[3].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_back} >
                                        <div className={LeaderWebViewStyles.flip_back_content} ref={backRef4} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.management[3].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.management[3].designation}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[3].name}</span>{t.management[3].description}
                                        </Typography>
                                    </div>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                        <Grid2
                            className={`${LeaderWebViewStyles.flip_card} ${isFlipped5 ? LeaderWebViewStyles.is_flipped : ''}`}
                            onTouchStart={handleTouchStart3}
                            onTouchMove={handleTouchMove3}
                            onTouchEnd={handleTouchEnd3(setIsFlipped5)}
                            sx={{ marginTop: "82px" }}
                        >
                            <Grid2 className={LeaderWebViewStyles.flip_card} >
                                <Grid2 className={LeaderWebViewStyles.flip_card_inner}>
                                    {/* Front Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_front}>
                                        <img src={Manish} alt="leaderpic" className={LeaderWebViewStyles.picture} />
                                        <Typography className={LeaderWebViewStyles.ex_subtit}>{t.management[4].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1}>{t.management[4].designation}</Typography>
                                    </Grid2>
                                    {/* Back Side */}
                                    <Grid2 className={LeaderWebViewStyles.flip_card_back1} >
                                        <div className={LeaderWebViewStyles.flip_back_content} ref={backRef5} tabIndex={0} role="region" aria-label={`Management profile details`}>
                                        <Typography className={LeaderWebViewStyles.ex_subtitback}>{t.management[4].name}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit1back}>{t.management[4].designation}</Typography>
                                        <Typography className={LeaderWebViewStyles.ex_subtit2}>
                                            <span className={LeaderWebViewStyles.span} style={{ fontWeight: 600 }}>{t.management[4].name}</span>{t.management[4].description}
                                        </Typography>
                                    </div>
                                    </Grid2>
                                </Grid2>
                            </Grid2>
                        </Grid2>

                    </Grid2>

                </Grid2>
            </Box>
        </>
    )
}